import { params } from '../modules/events/movePages';
import { apiClient } from '../utils/api';
import { getLocalTimezoneName } from '../utils/getLocalTimezoneName';

export async function createLead(data) {
    if (parseInt(params('has_source')) === 1) {
        data['source'] = params('source');
    }
    return await apiClient.POST(`api/leads`, data);
}

export async function updateLead(id, data) {
    return await apiClient.POST(`api/leads/${id}`, data);
}

export async function updateLeadStep(id, step, sessionEnded = 'false') {

    if (step === 'question') {
        return await apiClient.PUT(
            `api/leads/${id}/step/${step}/true`
        );
    }

    if (step === 'consult') {
        const timezone = getLocalTimezoneName();
        return await apiClient.PUT(
            `api/leads/${id}/step/${step}${sessionEnded ? `/${sessionEnded}` : ''}`,
            {
                ...(timezone && { timezone })
            }
        );
    }

    return await apiClient.PUT(
        `api/leads/${id}/step/${step}${sessionEnded ? `/${sessionEnded}` : ''}`
    );
}

/**
 * End the lead's widget session immediately (drop-off collection).
 * Uses fetch + keepalive (NOT axios) so the request survives page unload
 * when fired from pagehide, and keeps flying if the tab closes mid-request.
 */
export function endLeadSession(id) {
    try {
        return fetch(apiClient.apiUrl(`api/leads/${id}/end-session`), {
            method: 'POST',
            keepalive: true,
            headers: apiClient.config().headers,
        }).catch(() => null);
    } catch (e) {
        return Promise.resolve(null);
    }
}
